import React, { Component } from "react";
import { observer } from "mobx-react";
import { Row, Label } from "reactstrap";
import ModalForm from "../../comum/components/ModalForm";
import FormInput from "../../comum/components/FormInput";
import FormInputCNPJCPF from "../../comum/components/FormInputCNPJCPF";
import { observable } from "mobx";
import ModalAviso from "../../comum/components/ModalAviso";
import { isInvalidoCodigoContainer } from "../../../utils/validadores";

@observer
export default class AddAgendVgm extends Component {
  @observable mensagem = "";
  @observable salvando = false;
  constructor(props) {
    super(props);
    this.state = {
      container: "",
      cpf: "",
      nomecompleto: ""
    };
  }

  salvar = async () => {
    if (this.validate()) {
      this.salvando = true;
      const retorno = await this.props.salvar(this.state);
      this.salvoComSucesso = retorno.success;
      this.mensagem = retorno.message;
      this.salvando = false;
    } else {
      this.mensagem = "Preencha todos os campos obrigatórios";
    }
  };

  validate = () => {
    return this.state.container && this.state.cpf && this.state.nomecompleto;
  };

  preencheCampo = (campo, valor) => {
    this.setState({ [campo]: valor.toUpperCase() });
  };

  render() {
    const noCursor = { cursor: "auto" };
    return (
      <div>
        <ModalForm
          onClickCancelar={this.props.toggleModal}
          onClickSalvar={this.salvar}
          salvando={this.salvando}
        >
          <div style={noCursor}>
            <h2>Solicitação de pesagem VGM</h2>
            <Row>
              <FormInput
                titulo="Container"
                obrigatorio={true}
                autoFocus={true}
                limiteMaximo={11}
                validador={isInvalidoCodigoContainer}
                value={this.state.container}
                onChange={e => this.preencheCampo("container", e.target.value)}
              />
              <FormInputCNPJCPF
                titulo="CPF"
                obrigatorio={true}
                limiteMaximo={12}
                value={this.state.cpf}
                onChange={e => this.preencheCampo("cpf", e.target.value)}
              />
            </Row>
            <Row>
              <FormInput
                xl={12}
                titulo="Nome completo"
                obrigatorio={true}
                value={this.state.nomecompleto}
                onChange={e =>
                  this.preencheCampo("nomecompleto", e.target.value)
                }
              />
            </Row>
            {!this.salvoComSucesso && (
              <Label className="label-danger">{this.mensagem}</Label>
            )}
          </div>
        </ModalForm>
        {this.salvoComSucesso && (
          <ModalAviso onClickFechar={this.props.toggleModal}>
            <h2>{this.mensagem}</h2>
          </ModalAviso>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agend-vgm/componentes/AddAgendVgm.js